import styled from 'styled-components';
import { Box, Heading } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { maxWidths } from '@99designs/emu/settings';
import { useIsExperimentActivated } from '@99designs/experiments';
import HowItWorksContent from './HowItWorksContent';
import HowItWorksImage from './HowItWorksImage';
import HowItWorksVideo from './HowItWorksVideo';
import type { ProductLandingGroupKey } from '../../../lib/productLandingGroups';

export interface HowItWorksProps {
    heading: string;
    contestDescription: string;
    pricingLink: string;
    categoryKey: ProductLandingGroupKey;
    pricingOptions: string;
}

const FlexContainer = styled(Box)`
    ${mediaQuery.between('small', 'medium')} {
        flex-direction: column;
    }
`;

export default function HowItWorks({
    heading,
    contestDescription,
    pricingLink,
    categoryKey,
    pricingOptions,
}: HowItWorksProps) {
    const isContestFocusEnabled =
        useIsExperimentActivated('contestCenteredHomepageHero', 'enabled') &&
        categoryKey === 'logo-design';
    return (
        <Box marginY="none" background="#F3F2F0" minHeight="600px">
            <Box
                marginLeft="auto"
                marginRight="auto"
                paddingY={['3bu', '3bu', '4bu', '6bu']}
                paddingX={['1bu', '2bu', '2bu', '2bu']}
                maxWidth={`${maxWidths.content.widescreen}px`}
            >
                <Heading
                    appearanceLevel={3}
                    accessibilityLevel={5}
                    fontWeight="normal"
                    color="grey800"
                >
                    {heading}
                </Heading>

                <Box display="flex" flexDirection="column">
                    <FlexContainer
                        paddingTop={['1bu', '1bu', '2bu', '2bu']}
                        display="flex"
                        flexDirection="row"
                    >
                        <HowItWorksContent
                            contestDescription={contestDescription}
                            pricingLink={pricingLink}
                            categoryKey={categoryKey}
                            pricingOptions={pricingOptions}
                        />
                        {isContestFocusEnabled ? <HowItWorksImage /> : <HowItWorksVideo />}
                    </FlexContainer>
                </Box>
            </Box>
        </Box>
    );
}
